export default ({ user }) => user.permissions.can_filter_on_status;
